import React from 'react';
import { Component } from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import logo from '../../../assets/img/application_logo.png';
import { userFetchData } from '../../../redux/actions/userAction';

import { connect } from 'react-redux'
import heartbeats from 'heartbeats'

class LoginForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            user_email: false,
            user_password: false,
            showSnackbar: false
        }

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {

       	if(heartbeats.heart('refreshHeart')) {

       		heartbeats.heart('refreshHeart').killAllEvents();
       	}
        document.getElementById('name').focus();

        document.querySelector('title').innerHTML = 'MijnDP - Inloggen';
    }

    handleSubmit(e = false) {
        if(e) {
            e.preventDefault();
        }

        this.props.fetchData(this.props.clientPath + '/api/user/action/getToken', {user_email: this.state.user_email, password: this.state.user_password});
    }

    updateEmail(e) {
        this.setState({
            user_email: e.target.value
        });
    }

    updatePassword(e) {
        this.setState({
            user_password: e.target.value
        });
    }

    render() {
        return (
            <div>
                <div className="login-wrapper">
                    <div className="card">
                        <div className="card__body">
                            <div className="login-fields">
                                <img alt={"DP Logo"} src={logo} />
                                <form onSubmit={this.handleSubmit}>
                                    <TextField
                                        id="name"
                                        floatingLabelText="E-mailadres"
                                        fullWidth={true}
                                        onChange={(e) => this.updateEmail(e)}
                                        onKeyPress={(ev) => {
                                            if (ev.key === 'Enter') {
                                                this.handleSubmit()
                                            }
                                          }}
                                    />
                                    <TextField
                                        id="password"
                                        floatingLabelText="Wachtwoord"
                                        fullWidth={true}
                                        type="password"
                                        onKeyPress={(ev) => {
                                            if (ev.key === 'Enter') {
                                                this.handleSubmit()
                                            }
                                          }}
                                        onChange={(e) => this.updatePassword(e)}

                                    />


                                    <div className="pt20">
                                        <RaisedButton onClick={() => this.handleSubmit()} label="Log In" primary={true} fullWidth={true}/>
                                    </div>

                                    <div className="pt20">
                                        <RaisedButton href="/wachtwoord-vergeten" label={"Wachtwoord vergeten?"} primary={false} fullWidth={true}/>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (url, postData) => dispatch(userFetchData(url, postData)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm/index.js